import {Router} from '@angular/router';
import {MensagensService, ConfirmDialogOptions} from 'max-ng-lib';
import {Component, OnInit} from '@angular/core';
import {NotificacaoService} from '../../../../../services/notificacao.service';
import {FilialService, MotoristasService} from '../../../../../services';
import {SubheaderService} from '../../../../../core/services';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ColunaListaPaginada} from '../../../../pages/components/shared/components/lista-paginada/coluna-lista-paginada';
import {ColunaAcoesListaPaginada} from '../../../../pages/components/shared/components/lista-paginada/coluna-acoes-lista-paginada';
import {forkJoin, Observable} from 'rxjs';
import {PaginatorHelper, ParamPageable} from '../../../../pages/components/shared/components/lista-paginada/paginator-helper';
import {toQuery} from '../../../../../../utils/util';

@Component({
	selector: 'm-notificacoes',
	templateUrl: './notificacoes.component.html',
	styleUrls: ['./notificacoes.component.scss']
})
export class NotificacoesComponent implements OnInit {

	formsNotificacao: FormGroup;
	tiposNotificacao = [];
	notificacoes = [];
	motoristasNotificacoes = [];
	filiaisProvider = [];
	displayedColumns = ['idRegistro', 'mensagem', 'data'];
	provider: Observable<any>;
	paramPageable: ParamPageable;

	colunas: ColunaListaPaginada[] = [
		{
			nomeHeader: 'Código',
			nomeColuna: 'idRegistro',
			widthColuna: '10%',
			cellAlign: 'center',
			sortName: 'ID_REGISTRO'
		}, {
			nomeHeader: 'Notificações',
			nomeColuna: 'mensagem',
			widthColuna: '80%',
			cellAlign: 'center',
			sortName: 'MENSAGEM'
		}, {
			nomeHeader: 'Data',
			nomeColuna: 'data',
			widthColuna: '10%',
			cellAlign: 'center',
			sortName: 'DATA'
		}
	];

	acoes: ColunaAcoesListaPaginada[] =
		[
			{
				evento: (value) => this.detalhes(value),
				icone: 'far fa-eye',
				toolTip: 'Ver detalhes',
				toolTipDisable: 'Apenas Checkin Fora do Cliente OU Eventos',
				disable: (value) => (value.tipo !== 'E' && value.tipo !== 'K'),
			},
			{
				evento: (value) => this.dispensar(value),
				icone: 'fas fa-check',
				color: 'primary',
				toolTip: 'Dispensar notificação',
				toolTipDisable: '',
				disable: () => false
			},
			{
				evento: (value) => this.remover(value),
				icone: 'far fa-trash-alt remover',
				color: 'warn',
				toolTip: 'Deletar notificação.',
				toolTipDisable: '',
				disable: () => false
			}
		];

	constructor(public notificacaoService: NotificacaoService,
				private mensagens: MensagensService,
				private router: Router,
				private subheaderService: SubheaderService,
				private motoristaService: MotoristasService,
				private formBuilder: FormBuilder,
				private filialService: FilialService) {
	}

	ngOnInit() {
		this.carregarSubHeaders();
		this.criarFormularioNotificacao();
		this.carregarDadosIniciais();
		this.pesquisar();
	}

	carregarSubHeaders() {
		this.subheaderService.setTitle('Notificações');
		this.subheaderService.setBreadcrumbs([
			{title: 'Notificações', page: '/pages/notificacoes'},
		]);
	}


	criarFormularioNotificacao() {
		this.formsNotificacao = this.formBuilder.group({
			tipo: [null],
			mensagem: [null],
			dataInicial: [null],
			motoristas: [[]],
			filiais: [[]]
		});
	}

	carregarDadosIniciais() {
		forkJoin(
			this.notificacaoService.obterTipoNotificacaoPortal(),
			this.motoristaService.listarMotoristasComNotificacoes(),
			this.filialService.listarFiliaisPorUsuario()
		).subscribe(([tiposNotificacoes, motoristas, filiais]) => {
			this.tiposNotificacao = tiposNotificacoes;
			this.motoristasNotificacoes = motoristas;
			this.filiaisProvider = filiais;
		});
	}

	pesquisar() {
		this.paramPageable = new ParamPageable(10, 0, 'DATA,DESC');
		this.provider = this.notificacaoService.pesquisar(this.obterFiltroNotificacao(), toQuery(this.paramPageable));
	}


	changePaginator(paginator: PaginatorHelper) {
		this.paramPageable = new ParamPageable(paginator.size, paginator.page, paginator.sort);
		this.provider = this.notificacaoService.pesquisar(this.obterFiltroNotificacao(), toQuery(this.paramPageable));
	}

	obterFiltroNotificacao() {
		const {dataInicial, tipo, mensagem, motoristas, filiais} = this.formsNotificacao.value;
		return {
			dataInicial,
			tipo,
			mensagem,
			motoristas: motoristas && motoristas.length ? motoristas : null,
			filiais: filiais && filiais.length ? filiais : null
		};
	}

	detalhes(notificacao) {
		if (notificacao.tipo === 'E') {

			this.router.navigate(['/pages/consultas/eventos/edicao/', notificacao.idRegistro]);
		}

		if (notificacao.tipo === 'K') {

			this.router.navigate(['/pages/consultas/entregas/edicao/', notificacao.idRegistro]);
		}
	}

	remover(item: any) {
		this.mensagens
			.exibaConfirmDialog('Tem certeza que deseja remover a notificação?', 'Remover notificação')
			.subscribe(result => {
				if (result.confirmDialogSelect === ConfirmDialogOptions.SIM) {
					this.notificacaoService.dispensar(item.id)
						.subscribe(() => {
							this.pesquisar();
							this.mensagens.exibaToastSucesso('Notificação removida com sucesso!');
						});
				}
			});
	}

	limpar() {
		this.formsNotificacao.reset({
			tipo: null,
			mensagem: null,
			dataInicial: null,
			motoristas: [],
			filiais: []
		});
	}

	dispensar(item: any) {
		this.mensagens.exibaConfirmDialog('Deseja dispensar a notificação? A mensagem não será exibida novamente!', 'Dispensar notificação')
			.subscribe(result => {
				if (result.confirmDialogSelect === ConfirmDialogOptions.SIM) {
					this.notificacaoService.dispensar(item.id)
						.subscribe(() => {
							this.mensagens.exibaToastSucesso('Notificação dispensada!');
							this.pesquisar();
						});
				}
			});
	}

	dispensarTodos() {
		this.mensagens.exibaConfirmDialog('Deseja dispensar todas as notificações? As mensagens não serão exibidas novamente!', 'dispensar')
			.subscribe(result => {
				if (result.confirmDialogSelect === ConfirmDialogOptions.SIM) {
					this.notificacaoService.dispensarTodas()
						.subscribe(() => {
							this.mensagens.exibaToastSucesso('Notificações dispensadas!');
							this.pesquisar();
						});
				}
			});
	}
}
